import { reactive } from 'vue'

export const state = reactive({
  activeModal: '',
  graphLoaded: false,
  isEligibleForRecommendations: true,
  loading: false,
  preservationAge: 60,
  currentRiskProfile: 'balanced',
  riskRecommendation: 'balanced',
  selectedCurrentOption: false,
  showRecommendations: false,
})
